import { Flex } from '@withjoy/joykit';
import React from 'react';

export const CircleColoredIcon: React.FC<{ background: string }> = ({ background }) => {
  return (
    <Flex
      width={6}
      height={6}
      borderRadius="100%"
      background={background}
      border="1px solid rgba(0,0,0, 0.1)"
    />
  );
};
